import React from 'react'
import combineReducers from '../../utils/combineReducers'
import * as reservationResourcesReducer from '../../state/reservation/resources/reducer'
import getReservationResources from '../../state/reservation/resources/actions'

const ReservationResourcesContext = React.createContext(null)

function ReservationResourcesContextProvider(props) {
  // [A]
  const [state, dispatch] = React.useReducer(
    combineReducers({resources: reservationResourcesReducer.reducer}),
    {
      resources: reservationResourcesReducer.initialState,
    }
  )

  const getResources = React.useCallback(params => {
    getReservationResources(params)(dispatch)
  }, [])

  const value = {
    getResources,
    ...state,
  }

  // [B]
  return (
    <ReservationResourcesContext.Provider value={value}>
      {props.children}
    </ReservationResourcesContext.Provider>
  )
}

const ReservationResourcesContextConsumer = ReservationResourcesContext.Consumer

export {
  ReservationResourcesContext,
  ReservationResourcesContextProvider,
  ReservationResourcesContextConsumer,
}
